import { render, staticRenderFns } from "./swiperPage.vue?vue&type=template&id=b02e5bf2&scoped=true&"
import script from "./swiperPage.vue?vue&type=script&lang=js&"
export * from "./swiperPage.vue?vue&type=script&lang=js&"
import style0 from "./swiperPage.vue?vue&type=style&index=0&id=b02e5bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02e5bf2",
  null
  
)

export default component.exports